export const comments_5618856 = {"data":{"data":[],"links":{}}}